// @flow

import fastMemoize   from 'fast-memoize';
import { getConfig } from '../../config';

// -----------------------------------------------------------------------------------------------------------------
// Main function
// -----------------------------------------------------------------------------------------------------------------

const preparePublicPathTree = (): {} => memoizedPreparePublicPathTree(getConfig().publicBranches);

// -----------------------------------------------------------------------------------------------------------------
// Memoized builder
// -----------------------------------------------------------------------------------------------------------------

const memoizedPreparePublicPathTree = fastMemoize((publicBranches) =>
  publicBranches
    .concat([[getConfig().moduleStatePath]])
    .reduce((tree: {}, branch: Array<string>) => {
      let key: string;

      let branchClone = branch.slice(0);

      let treePointer = tree;

      do {
        key = branchClone.shift();

        if (branchClone.length) {
          treePointer[key] = treePointer[key] || {};
          if ('object' !== typeof treePointer[key]) {
            throw new Error('Branches overlap');
          }
          treePointer = treePointer[key];
        } else {
          if (treePointer[key]) {
            throw new Error('Branches overlap');
          }
          treePointer[key] = '*';
        }
      } while (branchClone.length);

      return tree;
    }, {}));

// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default preparePublicPathTree;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/utils/preparePublicPathTree.js